"use strict";
exports.__esModule = true;
exports.TaskPillsRow = void 0;
var styled_1 = require("@hiyllo/ux/styled");
var react_native_1 = require("react-native");
exports.TaskPillsRow = (0, styled_1.styledRN)(react_native_1.View, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap"
});
